import { render, staticRenderFns } from "./addBankCard.vue?vue&type=template&id=5310811b&scoped=true&"
import script from "./addBankCard.vue?vue&type=script&lang=js&"
export * from "./addBankCard.vue?vue&type=script&lang=js&"
import style0 from "./addBankCard.vue?vue&type=style&index=0&id=5310811b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5310811b",
  null
  
)

export default component.exports